import { List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { DSScreen, DSScreenMenuCell, DSScreenMenuCellItem } from 'kiolyn-api';
import React, { FC, Fragment } from 'react';
import { isNullOrUndefined } from 'util';
import ItemNameAndPrice from './ItemNameAndPrice';

interface MenuCellProps {
  screen: DSScreen;
  cell: DSScreenMenuCell;
}

const MenuCell: FC<MenuCellProps> = ({ screen, cell }: MenuCellProps) => {
  const items: DSScreenMenuCellItem[] = isNullOrUndefined(cell.items)
    ? []
    : cell.items;
  const denseStyle = {
    paddingTop: 0,
    paddingBottom: 0
  };
  return (
    <Fragment>
      <Typography
        key="category"
        style={{
          fontSize: screen.category_font_size + 'px',
          color: screen.category_color
        }}
      >
        {cell.name}
      </Typography>
      <List key="items">
        {items.map((item, index) => (
          <ListItem key={index} style={screen.dense ? denseStyle : {}}>
            {(item.show_hide_on_tv === undefined ||
              item.show_hide_on_tv === null ||
              item.show_hide_on_tv) && (
              <ListItemText
                primary={
                  <ItemNameAndPrice
                    item={item}
                    style={{
                      color: screen.item_color,
                      fontSize: screen.item_font_size
                    }}
                    showName2={cell.show_name_2}
                  />
                }
                secondary={
                  <Typography
                    style={{
                      fontSize: screen.description_font_size + 'px',
                      color: screen.description_color
                    }}
                  >
                    {item.description}
                  </Typography>
                }
                secondaryTypographyProps={{
                  style: {
                    color: screen.description_color
                  }
                }}
              />
            )}
          </ListItem>
        ))}
      </List>
    </Fragment>
  );
};

export default MenuCell;
